import { omit } from 'lodash'
import uuid from 'react-uuid'
import { when } from 'ts-pattern'

export const newUuid = () => `new_${uuid()}`

export const omitUuid = (obj) => {
  if (isUuidString(obj.id)) return omit(obj, ['id'])
  return obj
}

export const isUuidString = (string: any): boolean => {
  if (typeof string !== 'string') return false
  return string.includes('new')
}

export const matchRegExp = (regex: RegExp) => (str: string) => regex.test(str)
export const whenRegExp = (regex: RegExp) => when(matchRegExp(regex))

export const regexMatcher =
  (str: string) =>
  (...patterns: Array<[RegExp, any]>) => {
    const pattern = patterns.find((pat) => {
      const [reg] = pat
      return reg.test(str)
    })

    return pattern?.[1]
  }

export { humanize } from './string-utils'
